import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'callback',                
        loadComponent: () =>  import('./features/dashboard/callback/callback.component').then(m => m.CallbackComponent)
    },    
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
    },
    {
        path: 'dashboard',
        loadComponent: () =>  import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        data: {
            breadcrumb: 'Dashboard',
            label: 'Dashboard'
        },
        title: 'foo',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'overview'
            },
            {
                path: 'overview',
                loadComponent: () =>  import('./features/dashboard/profile/overview-section.component').then(m => m.OverviewSectionComponent),
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/dashboard/profile/overview/overview.component').then(m => m.OverviewComponent),
                        data: {
                            breadcrumb: 'Overview',
                            label: 'Overview'
                        },
                        title: 'Spark - Overview'
                    },
                    {
                        path: 'alerts',
                        loadComponent: () => import('./features/dashboard/profile/alerts/alerts.component').then(m => m.AlertsComponent),
                        data: {
                            breadcrumb: 'Alerts',
                            label: 'Alerts'
                        },
                        title: 'Spark - Alerts'
                    },
                    {
                        path: 'pending-approvals',
                        loadComponent: () => import('./features/dashboard/profile/alerts/alerts.component').then(m => m.AlertsComponent),
                        data: {
                            breadcrumb: 'Pending Approvals',
                            label: 'Pending Approvals'
                        },
                        title: 'Spark - Pending Approvals'
                    },
                    {
                        path: 'pending-tasks',
                        loadComponent: () => import('./features/dashboard/profile/alerts/alerts.component').then(m => m.AlertsComponent),
                        data: {
                            breadcrumb: 'Pending Tasks',
                            label: 'Pending Tasks'
                        },
                        title: 'Spark - Pending Tasks'
                    }                                     
                ]
            }
        ]
    },
    {
        path: 'organization-management',
        loadComponent: () =>  import('./features/organization-management/organization-list-section.component').then(m => m.OrganizationListSectionComponent),
        data: {
            breadcrumb: 'Organization management',
            label: 'Organization management'
        },
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'organization-list'
            },
            {
                path: 'organization-list',
                loadComponent: () =>  import('./features/organization-management/organization-list/organization-list.component').then(m => m.OrganizationListComponent),
                data: {
                    breadcrumb: 'Organization List',
                    label: 'Organization List'
                },
                title: 'Spark - Organization List',                      
            }
        ]
    },
    {
        path: 'user-management',
        loadComponent: () =>  import('./features/user-management/user-management-section.component').then(m => m.UserManagementSectionComponent),
        data: {
            breadcrumb: 'User management',
            label: 'User management'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'people-directory'
            },
            {
                path: 'people-directory',
                data: {
                    breadcrumb: 'People Directory',
                    label: 'People Directory'
                },
                title: 'Spark - People Directory',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all-users'
                    },
                    {
                        path: 'owners',
                        loadComponent: () =>  import('./features/user-management/all-users/all-users.component').then(m => m.AllUsersComponent),
                        data: {
                            breadcrumb: 'Owners',
                            label: 'Owners'
                        },
                        title: 'Spark - Owners'                
                    },
                    {
                        path: 'team-members',
                        loadComponent: () =>  import('./features/user-management/all-users/all-users.component').then(m => m.AllUsersComponent),
                        data: {
                            breadcrumb: 'Team members',
                            label: 'Team Mmmbers'
                        },
                        title: 'Spark - Team members'                
                    },
                    {
                        path: 'all-users',
                        loadComponent: () =>  import('./features/user-management/all-users/all-users.component').then(m => m.AllUsersComponent),
                        data: {
                            breadcrumb: 'All users',
                            label: 'User management'
                        },
                        title: 'Spark - All users'                
                    },
                    {
                        path: ':uid',
                        children: [
                            {
                                path: 'personal-details',
                                loadComponent: () =>  import('./features/user-management/personal-details/personal-details.component').then(m => m.PersonalDetailsComponent),
                                data: {
                                    breadcrumb: 'Personal details',
                                    label: 'User management'
                                },
                                title: 'Spark - Custom Data'
                            },
                            {
                                path: 'related-organizations',
                                loadComponent: () =>  import('./features/user-management/related-organizations/related-organizations.component').then(m => m.RelatedOrganizationsComponent),
                                data: {
                                    breadcrumb: 'Custom Data',
                                    label: 'User management'
                                },
                                title: 'Spark - Custom Data'
                            },
                            {
                                path: 'provisioning-roles',
                                loadComponent: () =>  import('./features/user-management/provisioning-roles/provisioning-roles.component').then(m => m.ProvisioningRolesComponent),
                                data: {
                                    breadcrumb: 'Custom Data',
                                    label: 'User management'
                                },
                                title: 'Spark - Custom Data'
                            }]
                    }                    
                ]         
            }                  
        ]
    },     
    {
        path: '**',
        redirectTo: 'dashboard'
    }
];
